/**
 * @property elem Calculator element
 * @property host API url
 *
 * @property country
 * @property language
 * @property currency
 * @property session_id
 * @property isCurrConverter
 * @property fund_out_mnem
 * @property fund_in
 *
 * @property countriesSelect Element
 * @property sendToCountry string
 * @property sendToCurrency string
 *
 * @property sendAmountElem Element
 * @property sendAmount float
 *
 * @property fxContainer Element
 * @property fxToElem Element
 *
 * @property feeContainer Element
 * @property feeElem Element
 */
class WUCalculator {

    /**
     * @param elem Element Calculator element
     * @param host string
     * @param country string
     * @param language string
     * @param currency string
     * @param session_id string
     * @param isCurrConverter boolean
     * @param fund_out_mnem string||null
     * @param fund_in string||null
     * @param defaultReceiverCurrency string||null
     * @param checkDefaultFXForReceiver boolean
     */
    constructor(elem, host, country, language, currency, session_id = '', isCurrConverter = false, fund_out_mnem = null, fund_in = null, defaultReceiverCurrency = null, checkDefaultFXForReceiver = false, isCurrencyConverterUpdated= false, channel, client) {

        if (typeof elem !== 'object' || !host || !country || !language || !currency ) {
            throw 'Constructor params required';
        }
        //init properties
        this.elem = elem;
        this.host = host;
        this.country = country;
        this.language = language;
        this.currency = currency;
        this.channel = channel;
        this.client = client;
        this.session_id = session_id;
        this.isCurrConverter = isCurrConverter;
        this.default_fund_out_mnem = fund_out_mnem ? fund_out_mnem : null;
        this.default_fund_in = fund_in ? fund_in : null;
        this.initFXTimeout = null;
        this.lastTouchedInput = null;
        this.defaultReceiverCurrency = defaultReceiverCurrency;
        this.isCurrConverterDefaultPage = checkDefaultFXForReceiver;
        this.displayFxRate = DisplayFxRateParamsService.getDisplayProp(`displayFxRate`);
        this.isCurrencyConverterUpdated = isCurrencyConverterUpdated;
        const initialDisplayFxRate = DisplayFxRateParamsService.getDisplayProp(`initialDisplayFxRate`);
        this.getReceiverId = `wu-input-receiver-gets-${this.currency}`;
        this.initFiFoObj = FifoService.setFifo(this.default_fund_out_mnem, this.default_fund_in );
        this.onPageLoad = true;
		this.queryParamSendAmount = false;
        this.countryDropdownSelect = this.elem.querySelector(".b-flag-select__value");
        //init send to countries
        this.countriesSelect = this.elem.querySelector('.countries');
        this.getStartedBtnSendMoney = document.getElementById('home-send-money');
        this.getStartedBtn = this.elem.querySelector('#home-get-started') || this.elem.querySelector('#corridor-get-started') || this.elem.querySelector('[data-id="button_get-started"]') || document.querySelector('#home-get-started')
        // this.strikeFeeEl = this.elem.querySelector('.striked-fee')
        this.diffFeeEl = this.elem.querySelector('.difference-fee')
        this.receiverStrikedEl = this.elem.querySelector('.strikethrough-receiver-amount')
        // this.currentFeeEl = this.elem.querySelector('.current-fee')
        this.extraMoneyEl = this.elem.querySelector('.extraMoney')
        this.strikeFxTo = this.elem.querySelector('.strike-fx-to')
        this.extraMoneyParent = this.elem.querySelector('#extraMoneyParent')
        this.differenceFeeParent = this.elem.querySelector('#differenceFeeParent')
        this.spinnerEl = document.getElementById('spinnerContainer')
        // this.strikedFeeToText = this.elem.querySelector('.striked-fee-to-text')
        this.strikeFxToText = this.elem.querySelector('.strike-fx-to-text')
        this.strikeFxFromText = this.elem.querySelector('.strike-fx-from-text')
        this.extraMoneyInitValue = this.extraMoneyEl && this.extraMoneyEl.innerText
        this.diffFeeElInitValue = this.diffFeeEl && this.diffFeeEl.innerText 
        if (!this.countriesSelect && !this.isCurrConverter) {
            throw 'Countries select not found';
        }
        // get send mount elem
        this.sendAmountElem = this.elem.querySelector('.amount');
        if (!this.sendAmountElem) {
            throw 'Send amount input not found';
        }
        this.blockMinusSign(this.sendAmountElem);
        this.sendAmountElem.addEventListener('input', (e) => e.target.setAttribute('value', e.target.value))
        let currencyConverterAmount = sessionStorage.getItem('currency-converter-amount');
        currencyConverterAmount = currencyConverterAmount === 'undefined' ? this.sendAmountElem?.value : currencyConverterAmount
        this.addListenerOnGetStartedBtn();
        this.sendToCountry = this.handleCurrencyConverter() || this.countriesSelect.value;
        this.sendToCurrency = getCurrencyFromPriceCorridor(this.sendToCountry) || ISO_CODES_COUNTRIES_CURRENCIES[this.sendToCountry.toUpperCase()];
        let userSelectedValuesFromCookies = CookieService.getParsedCookieValue('userSelectedValues');
        if (userSelectedValuesFromCookies && !this.isCurrConverter) {
            let objValues = userSelectedValuesFromCookies;
            this.sendToCountry = objValues.Country_Selected;
            this.sendToCurrency = objValues.Currency_Selected;
        }

        if(this.isCurrConverter && currencyConverterAmount && !this.queryParamSendAmount){            
            this.sendAmountElem.value = currencyConverterAmount;
        } 
        if(!this.isCurrConverter || this.queryParamSendAmount){
            sessionStorage.removeItem('currency-converter-amount');
        }

        this.setFifoValue = () => {
            const dataFundOutImportant = this.elem?.getAttribute(`data-fund-out-important`)
            const dataFundInImportant = this.elem?.getAttribute(`data-fund-in-important`)
            let getFifoObj = FifoService.getFifo(this.sendToCountry, this.isCurrConverter);
            let isTop20Corridor = false;
            if (getFifoObj && getFifoObj.type === `top_20_corridor`) {
                isTop20Corridor = true;
            }
            if (getFifoObj && getFifoObj.FifoValue) {
                this.fund_in = isTop20Corridor ? getFifoObj.FifoValue[0] : getFifoObj.FifoValue.FundsIn;
                this.fund_out_mnem = isTop20Corridor ? getFifoObj.FifoValue[1] : getFifoObj.FifoValue.FundsOut;
                getFifoObj.FifoValue[2] = this.checkUserAmountValue() ? parseInt(this.sendAmountElem.value,10) : getFifoObj.FifoValue[2];
                isTop20Corridor ? getFifoObj.FifoValue[2] && this.setSendAmountValue(`${getFifoObj.FifoValue[2]}.00`) : this.prevInputValue &&  this.setSendAmountValue(this.prevInputValue);
            }
            if(dataFundOutImportant) {
                this.fund_out_mnem = dataFundOutImportant
            } 
            if(dataFundInImportant) {
                this.fund_in = dataFundInImportant
            }
        }
        this.checkUserAmountValue = () => {
            return  ((this.sendAmountElem.dataset.value != this.sendAmountElem.value) && (this.sendAmountElem.dataset.value != this.prevInputValue)) ? true : false;
         }


        this.setSendAmountValue = (amnt) => {
            if(!this.queryParamSendAmount){
                this.sendAmount = amnt;
                this.sendAmountElem.value = amnt;
                this.sendAmountElem.setAttribute('value', amnt);
                amnt && this.sendAmountElem.classList.add('wu-input--is-focus');
            }
        }

        //this.checkTopCorridorConfig(true);
        //this.sendAmount = this.sendAmountElem.value;
        !this.isCurrConverter && (this.countriesSelect.onchange = () => {
            if (this.sendToCountry !== this.countriesSelect.value) {
                this.sendToCountry = this.countriesSelect.value;
                this.sendToCurrency = getCurrencyFromPriceCorridor(this.sendToCountry) || ISO_CODES_COUNTRIES_CURRENCIES[this.sendToCountry.toUpperCase()];
                window.evergageMsgLoaded = false;
                //this.checkTopCorridorConfig();
                this.setFifoValue();
                this.triggerEventForEvergage();
                !window.evergageMsgLoaded && this.initFX();
            }
        })

        this.getValuesFromParam = () => {
            const arr = [`ReceiveCountry`, `SendAmount`];
            const isParamPresent = this.getParamFromUrl();
            this.getCountryFromParam = isParamPresent && this.checkReceiverCountryInUrl(arr);
            let sendCountryObj = this.getCountryFromParam && this.getCountryFromParam.ReceiveCountry && countryCurrencyDefaults.countries.find(c => c.country.isoCode.toLowerCase() === this.getCountryFromParam.ReceiveCountry.toLowerCase());
            const cookieSendAmount = CookieService.getParsedCookieValue('userSelectedValues');
            cookieSendAmount && this.setSendAmountValue(cookieSendAmount['Amount_Selected']);
            if(this.getCountryFromParam && sendCountryObj){
                this.sendToCountry = sendCountryObj.country.isoCode;
                this.sendToCurrency = sendCountryObj.country.currencies[0].currency;
                this.setSendAmountValue (this.getCountryFromParam.SendAmount);
            }
        }

        this.prevInputValue = this.sendAmountElem.value;
        this.setFifoValue();
        this.onPageLoad &&  !this.isCurrConverter && this.getValuesFromParam();
        this.onPageLoad = false;
        this.sendAmountElem.onkeyup = () => {
            if (!(+this.sendAmountElem.value) || +this.sendAmountElem.value < 0) { // avoids api call for values like '', '0', '00', negatives etc 😊
                // A quote scheduled by an earlier valid keystroke would otherwise fire with this value.
                clearTimeout(this.initFXTimeout);
                this.initFXTimeout = null;
                // Otherwise re-entering the previous valid amount is skipped as "unchanged".
                this.prevInputValue = null;
                this.handleEmptyInp('sender');
                this.changeButtonLink(this.fund_out_mnem);
                return
            }
            if (this.sendAmountElem.value && (this.prevInputValue != this.sendAmountElem.value)) {
                if (this.initFXTimeout != null) {
                    clearTimeout(this.initFXTimeout)
                }
                if (this.getStartedBtn) {
                    let getUrl = this.getStartedBtn.getAttribute("href");
                    this.getStartedBtn.setAttribute("href", getUrl.replace(/(&SendAmount)[^\&]+/, `$1=${this.sendAmountElem.value}`))
                    this.getStartedBtnSendMoney && this.getStartedBtnSendMoney.setAttribute("href", getUrl.replace(/(&SendAmount)[^\&]+/, `$1=${this.sendAmountElem.value}`))
                }
                if (!this.isCurrencyConverterUpdated) {
                    let receiveAmount = parseFloat(this.sendAmountElem.value * this.fxToElem.innerHTML.split(" ")[0]).toFixed(2);
                    if (this.receiveAmountElem)
                        this.receiveAmountElem.value  = receiveAmount;
                } else {
                    this.receiveAmountElem.value  = '';
                }
                this.changeButtonLink(this.fund_out_mnem);
                this.prevInputValue = this.sendAmountElem.value
                if (this.isCurrencyConverterUpdated) {
                    resetStrikedFeeAndEl(this.extraMoneyEl, this.extraMoneyInitValue, this.diffFeeEl, this.receiverStrikedEl, this.feeElem, this.extraMoneyParent, this.differenceFeeParent, this.diffFeeElInitValue, this.feeElemText, this.feeContainer);
                }
                this.initFXTimeout = setTimeout(() => {
                    this.initFXTimeout = null
                    this.sendAmount = this.sendAmountElem.value;
                    this.initFX();
                }, 500)
            }
        }

        this.receiveAmountElem = document.getElementById(this.getReceiverId);
        this.prevReceiverValue = this.receiveAmountElem ? this.receiveAmountElem.value: null;
        if(this.receiveAmountElem) {
            this.receiveAmountElem.onkeyup = () => {
                if (!(+this.receiveAmountElem.value)) {
                    this.handleEmptyInp('receiver')
                    return
                }
                resetStrikedFeeAndEl(this.extraMoneyEl, this.extraMoneyInitValue, this.diffFeeEl, this.receiverStrikedEl, this.feeElem, this.extraMoneyParent, this.differenceFeeParent, this.diffFeeElInitValue, this.feeElemText, this.feeContainer);
                document.dispatchEvent(new CustomEvent('triggerReceiveAmountElem'));		
            }
        }

        //init fx
        this.fxContainer = this.elem.querySelector('.fx-container');
        this.feeContainer = this.elem.querySelector('.fee-container');
        this.fxToElem = this.fxContainer.querySelector('.fx-to');
        if (!this.fxContainer || !this.fxToElem) {
            throw 'FX element not found';
        }

        //init fee
        this.feeContainer = this.elem.querySelector('.fee-container');
        this.feeElem = this.feeContainer.querySelector('.fee');
        this.feeElemText = this.feeElem.innerText;
        if (!this.feeContainer || !this.feeElem) {
            throw 'Fee element not found';
        }
        this.assignSubscriptionId();
        this.triggerEventForEvergage();
        if (initialDisplayFxRate) {
            this.initFX(); // default api call.
        } else {
            // If page is currency-converter.html and have defaultReceiverCurrency then fetch inital FX
            if (this.isCurrConverterDefaultPage) {
                this.initFX();
            }
            this.changeButtonLink(this.fund_out_mnem);
        }
        /** 
         * If campaigns are already loaded at this point then event handler wont be executed.
         * And in cases where campaigns are loaded after this code executes, api call will happen twice, first
         * the default one and then at campaign load event. 🙈 
        */
        window.addEventListener('campaignLoadedEvent', (() => {
            let timerId;
            return () => {
                clearTimeout(timerId);
                // setTimeout will evoke a macrotask and will execute at last dispatched event.
                timerId = setTimeout(() => {
                    this.triggerEventForEvergage();
                })
            }
        })());
        window.addEventListener('campaignMessageLoaded', () => {
            this.initFX();
        });
    }

    blockMinusSign(input) {
        input.addEventListener('keydown', e => {
            if (['-', '+', 'e', 'E'].includes(e.key)) e.preventDefault();
            // Native stepping changes the amount unexpectedly.
            if (['ArrowUp', 'ArrowDown'].includes(e.key)) e.preventDefault();
        });
        input.addEventListener('beforeinput', e => {
            if (e.data && e.data.includes('-')) e.preventDefault();
        });
        input.addEventListener('paste', e => {
            const text = e.clipboardData?.getData('text') ?? '';
            if (text.includes('-')) {
                e.preventDefault();
                input.value = text.replace(/-/g, '');
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });
        // Covers drag-drop and autofill, which skip the key and paste events.
        input.addEventListener('input', () => {
            if (/[-+eE]/.test(input.value)) input.value = input.value.replace(/[-+eE]/g, '');
        });
    }

    getParamFromUrl() {
        let params = window.location.search || window.location.hash
        if(params === "" || params.indexOf('lang') > -1 || params.indexOf('evergage') > -1){
            params = null;
        }
        return params;
    }

    getURLParameter(name) {
        const urlParams = this.getParamFromUrl();
        let returnValue = urlParams && decodeURIComponent((new RegExp(`[?|&]` + name + `=` + `([^&;]+?)(&|#|;|$)`).exec(urlParams) || [, ""])[1].replace(/\+/g, `%20`)) || null
        if (returnValue !== undefined && returnValue !== null) {
            returnValue = returnValue.trim();
        }
        return returnValue;
    }

    checkReceiverCountryInUrl(elem){
        let queryParamObj = {}
        elem.forEach(element => {
            queryParamObj[element] = this.getURLParameter(element)
            if(queryParamObj[element] === null){
                return null;
            }
        });
        return queryParamObj;
    }
    
    assignSubscriptionId() {
        const name = `promoCampaignSubscriptionId=`;
        const ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") c = c.substring(1);
            if (c.indexOf(name) === 0) this.subscriptionId = c.substring(name.length, c.length);
        }
    }

    triggerEventForEvergage() {
        const name = this.isCurrConverter ? countryCurrencyDefaults.countries.find(c => c.country.isoCode === this.sendToCountry)?.country?.name
            : this.countriesSelect.options[this.countriesSelect.selectedIndex]?.text;
        if(name) {
            const event = new CustomEvent('countryChangeEvent', { detail: { country: { isoCode: this.sendToCountry, name } } });
            window.dispatchEvent(event);
        }
    }

    /** 
     * @method to  assign '0' in receiver/sender if values like '', '0', '00' are entered in the other input, and hides fx and fee
    */
    handleEmptyInp(inp) {
        if(!this.isCurrencyConverterUpdated) {
            (inp === 'receiver') ? this.sendAmountElem.value = '0' : (this.receiveAmountElem && (this.receiveAmountElem.value = '0'))
            this.renderFXText(null)
        }
        this.renderFeeText(null)
    }

    toggleClasses(el, classOne, classTwo, value) {
        classOne && el.classList.toggle(classOne, value === null)
        classTwo && el.classList.toggle(classTwo, value !== null)
    }

    renderFeeText(fee) {
        this.toggleClasses(this.feeContainer, 'd-none', 'd-flex', fee);
        this.toggleClasses(this.feeContainer, '', 'd-M-inline-flex', fee);
        if (fee !== null && !this.isCurrencyConverterUpdated) {
            this.feeElem.innerHTML = fee.toFixed(2) + ' ' + this.currency.toUpperCase();            
        }
    }

    renderFXText(fx) {
        this.toggleClasses(this.fxContainer, 'd-none', 'd-inline-flex', fx);
        if (fx) {
            const displayCurrencyCode = this.sendToCurrency && (ChangeCountryCurrency[this.sendToCountry.toUpperCase()] || this.sendToCurrency.toUpperCase());
            const fixedCharsToShow = this.isCurrencyConverterUpdated ? 2 : 4
            this.fxToElem.innerHTML = fx.toFixed(fixedCharsToShow) + ' ' + displayCurrencyCode;
            const faqCurrDate = document?.querySelector('#faqCurrDate');
            const faqExchRate = document?.querySelector('#faqExchRate');
            faqCurrDate && (faqCurrDate.textContent = formatUTCDate());
            faqExchRate && (faqExchRate.textContent = fx.toFixed(fixedCharsToShow));
        }
    }

    changeButtonLink(selectedFundsOut, selectedFundsIn) {
        const dataIsCorridor = this.getStartedBtn.getAttribute('data-is-corridor')
        const href = this.getStartedBtn.getAttribute("href")
        if (dataIsCorridor === 'true') {
            const dataCorridor = this.getStartedBtn.getAttribute(`data-corridor-${this.sendToCountry}`)
            if (dataCorridor) {
                this.getStartedBtn.setAttribute('href', dataCorridor)
            } else {
                this.getStartedBtn.setAttribute('href', `/${this.country}/${this.language}/send-money.html?ReceiverCountry=${this.sendToCountry}`)
            }
        } else {
            const getUrl = this.getStartedBtn ? `${href}`.split("?")[0] : null;
            let [funds_out_name, funds_in_name] = WuAmerigoConfigs.isAmerigo() ? [AmerigoPayOut[selectedFundsOut], AmerigoPayIn[this.fund_in]] : [CloudPayOut[selectedFundsOut], CloudPayIn[this.fund_in]];
            if (!funds_in_name && selectedFundsIn) {
                funds_in_name = selectedFundsIn;
            }
            const getParamForUrl = getParams(this.sendToCountry.toUpperCase(), this.sendToCurrency, this.sendAmountElem.value, funds_out_name, funds_in_name,this.language, getUrl);
            const isUae = getUrl && getUrl.indexOf(uaeCheck) !== -1;
            const url = getUrl && `${getUrl}${getParamForUrl}`;
            if (this.sendAmountElem.value && this.sendToCountry && this.getStartedBtn && !isUae) {
                this.getStartedBtn.setAttribute("href", url)
            } else {
                this.getStartedBtn.setAttribute("href", getUrl)
            }
            if (isUae && this.getStartedBtnSendMoney) {
                this.getStartedBtnSendMoney.setAttribute("href", getUrl)
            } else if (this.getStartedBtnSendMoney) {
                this.getStartedBtnSendMoney.setAttribute("href", url)
            }
        }
        const queryParams = this.getStartedBtn?.href?.split("?")?.[1] || this.getStartedBtnSendMoney?.href?.split("?")?.[1]
        queryParams && setNavSendMoneyParams(`?${queryParams}`)
    }

    /**
     * change fx and fee by country select and amount input
     */
    initFX(receiveAmount) {
        this.changeButtonLink(this.fund_out_mnem);
        // sendAmount can also come from the URL or cookies, so the keyup guard alone is not enough.
        if (parseFloat(this.sendAmount) < 0 || parseFloat(this.sendAmountElem?.value) < 0) {
            return;
        }
        if(this.displayFxRate || this.isCurrConverterDefaultPage){
            const reqPayload = {
                currency: this.currency,
                country: this.country,
                funds_in: this.fund_in,
                fund_out_mnem: this.fund_out_mnem,
                host: this.host,
                channel: this.channel,
                client: this.client,
                sendAmount: this.sendAmount,
                sendToCurrency: this.sendToCurrency || 'GBP',
                subscriptionId: this.subscriptionId,
                sendToCountry: this.sendToCountry || 'gb',
                ...(receiveAmount && {
                    receiveAmount
                })

            }

            let priceCatalogConfig = triggerPriceCatalog(reqPayload, this.isCurrencyConverterUpdated,this.isCurrencyConverterUpdated);
            const isR4Country = getR4Country();
            toggleClass && this.spinnerEl && toggleClass(this.spinnerEl,'d-none','d-flex')
            dataCatalogProduct(
              this.isCurrencyConverterUpdated,
              this.country,
              this.language,
              {
                country: this.country,
                sendToCountry: this.sendToCountry,
                language: this.language,
                sendAmount: this.sendAmount,
                fund_in: this.fund_in,
                fund_out_mnem: this.fund_out_mnem,
                channel: this.channel,
                client: this.client,
              },
              priceCatalogConfig
            )
              .then((response) => {
                toggleClass &&
                  this.spinnerEl &&
                  toggleClass(this.spinnerEl, "d-flex", "d-none");
                let filteredResp =
                  isR4Country && !this.isCurrencyConverterUpdated
                    ? response
                    : priceCatalogConfig.initApi(response);
                const handleCalcCall = ({
                  strikeReceiveAmount,
                  strike_fee,
                  strike_fx_rate,
                  fx,
                  fee,
                  receiveAmount,
                  sendAmount,
                  selectedFundsIn,
                  fundsIn
                }) => {
                  this.changeButtonLink(this.fund_out_mnem, selectedFundsIn ? selectedFundsIn : fundsIn);
                  toggleClass &&
                    this.spinnerEl &&
                    toggleClass(this.spinnerEl, "d-flex", "d-none");
                  if (this.lastTouchedInput !== "receiverAmtField") {
                    this.receiverAmount = receiveAmount.toFixed(2);
                    if (this.receiveAmountElem) {
                      this.receiveAmountElem.value = this.receiverAmount;
                      this.receiveAmountElem.classList.add(
                        "wu-input--is-focus"
                      );
                    }
                  } else if (this.lastTouchedInput === "receiverAmtField") {
                    this.sendAmount = sendAmount.toFixed(2);
                    if (this.sendAmountElem) {
                      this.sendAmountElem.value = this.sendAmount;
                    }
                  }
                  this.lastTouchedInput = null;
                  //render fx
                  this.renderFXText(fx);
                  this.isCurrencyConverterUpdated &&
                    renderStrikedFxAndFee(
                      strike_fee,
                      fee,
                      strikeReceiveAmount,
                      receiveAmount,
                      strike_fx_rate,
                      this.extraMoneyParent,
                      this.differenceFeeParent,
                      this.strikeFxToText,
                      this.strikeFxTo,
                      this.receiverStrikedEl,
                      this.feeElem,
                      this.receiveAmountElem,
                      this.currency,
                      this.sendToCurrency,
                      this.sendAmount,
                      this.extraMoneyEl,
                      this.diffFeeEl,
                      this.feeElemText,
                      undefined,
                      undefined,
                      undefined,
                      this.strikeFxFromText,
                      fx && fx.toFixed(2)
                    );
                  //render fee
                  this.renderFeeText(fee);
                };
                handleCalcCall(
                  filteredResp || {
                    fx: null,
                    fee: null,
                    receiveAmount: 0,
                    sendAmount: 0,
                  }
                );
              })
              .catch((error) => {
                toggleClass &&
                  this.spinnerEl &&
                  toggleClass(this.spinnerEl, "d-flex", "d-none");
                console.log("error", error);
              });
        }
    }
    /** @method to populate send amount value from query param in case of currency converter pages */
    handleQueryParam() {
       const queryParam = new URLSearchParams(window.location.search);
       const amount = queryParam.get('sendAmount');
       const spanEl = document.querySelector('.dynamic-send-amount');

       if (amount && !isNaN(amount)) {
        this.sendAmount = this.sendAmountElem.value = Number(amount);
        this.queryParamSendAmount = true;
        spanEl?.classList.remove('d-none');
        if (spanEl) spanEl.textContent = amount;
       } else {
        spanEl?.classList.add('d-none');
       }
    }

    handleCurrencyConverter() {
        const defaultReceiverCurrencyElement = this.elem.querySelector('#default-receiver-currency');
        const pathSplit = window.location.pathname.split('-');
        const receiverCurr = this.isCurrConverterDefaultPage ? this.defaultReceiverCurrency.toUpperCase() : pathSplit[pathSplit.length - 2] && pathSplit[pathSplit.length - 2].toUpperCase();
        if (this.isCurrConverter && receiverCurr) {
            defaultReceiverCurrencyElement && defaultReceiverCurrencyElement.setAttribute('data-default-receiver-currency-name', receiverCurr);
            !this.isCurrConverterDefaultPage && this.handleQueryParam()
            const currencyCodeElement = this.elem.querySelector(`span[title=${receiverCurr.toUpperCase()}]`);
            const receiverCurrency = this.elem.querySelector('.currency-select-dropdown .wu-input-currency-text,.currency-selects-dropdown .wu-input-currency-text');
            receiverCurrency ? receiverCurrency.textContent = receiverCurr : undefined;
            // Read Country Code from Element and if not present read from the maintained list ISO_CODES_COUNTRIES_CURRENCIES.
            const countryCode = currencyCodeElement && currencyCodeElement.getAttribute("data-countrycode");
            if (countryCode) {
                const receiverFlag = this.elem.querySelector('.currency-select-dropdown .wu-flag,.currency-selects-dropdown .wu-flag');
                receiverFlag? receiverFlag.classList.add(countryCode.toLowerCase()) : undefined;
                return countryCode;
            } else if(this.isCurrencyConverterUpdated && defaultReceiverCurrencyElement && defaultReceiverCurrencyElement.getAttribute('data-default-receiver-country')) {
                return defaultReceiverCurrencyElement.getAttribute('data-default-receiver-country')
            } else {
                for (let code in ISO_CODES_COUNTRIES_CURRENCIES) {
                    if (ISO_CODES_COUNTRIES_CURRENCIES[code] === receiverCurr) return code;
                }
            }
        }
    }

    addListenerOnGetStartedBtn() {
        if (this.getStartedBtn) {
            this.getStartedBtn.addEventListener('click', e => {
                let userSelectedValues = {
                    'Country_Selected': this.sendToCountry,
                    'Currency_Selected': this.sendToCurrency,
                    'Amount_Selected': this.sendAmountElem.value
                };
                CookieService.setCookie('userSelectedValues', JSON.stringify(userSelectedValues),365,location.pathname);
            })
        }
    }
}

let calc;
document.addEventListener('countrylist', () => {
    console.log('Country list is generated')
    try {
        const calcElements = document.querySelectorAll('.calculator');
        const getReceiverCurrencyDropElement = document.getElementById('default-receiver-currency');
        const receiverCurrencyDropValue = getReceiverCurrencyDropElement ? getReceiverCurrencyDropElement.getAttribute('data-default-receiver-currency-name') : null;
        for (let i = 0; i < calcElements.length; i++) {
            const isCurrencyConverterUpdated = !!(document.querySelector('section.currency-converter-updated') && calcElements[i].closest(".currency-converter-updated"))
            const ccBlockOnNormalPage = calcElements[i].getAttribute('data-other-than-cc') === 'true';
            let checkCurrencyConverter = ( /\/currency-converter\/.+\.html$/.test(window.location.pathname) || /\/currency-converter-(.)*.html/.test(window.location.pathname) || isCurrencyConverterUpdated || ccBlockOnNormalPage);
            const checkCurrConverterMain = !checkCurrencyConverter && window.location.pathname.indexOf('/currency-converter') > -1;
            const checkDefaultFXForReceiver = (((/\/currency-converter.html/.test(window.location.pathname) || /\/currency-converter-v2.html/.test(window.location.pathname)) && receiverCurrencyDropValue) || isCurrencyConverterUpdated || ccBlockOnNormalPage) ? true : false;
            checkCurrencyConverter = checkDefaultFXForReceiver ? checkDefaultFXForReceiver : checkCurrencyConverter;
            calc = new WUCalculator(
                calcElements[i],
                calcElements[i].getAttribute('data-host') || 'https://www.westernunion.com/',
                calcElements[i].getAttribute('data-country') || 'au',
                calcElements[i].getAttribute('data-language') || 'en',
                calcElements[i].getAttribute('data-currency') || 'AUD',
                calcElements[i].getAttribute('data-session-id'),
                checkCurrencyConverter,
                calcElements[i].getAttribute('data-fund-out-mnem') || 'DB',
                calcElements[i].getAttribute('data-fund-in') || '*',
                receiverCurrencyDropValue,
                checkDefaultFXForReceiver,
                isCurrencyConverterUpdated,
                calcElements[i].getAttribute('data-channel') || 'WWEB',
                calcElements[i].getAttribute('data-client') || 'WUCOM'
            );
            (!checkCurrConverterMain || checkDefaultFXForReceiver) && calc
             
        }
    } catch (e) {
        console.error('WUCalculator', e);
    }
})
